var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyTeamCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3119_3554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8501 41.7197C2.8501 63.8097 20.7601 81.7197 42.8501 81.7197C64.9401 81.7197 82.8501 63.8097 82.8501 41.7197C82.8501 19.6297 64.9401 1.71973 42.8501 1.71973C20.7601 1.71973 2.8501 19.6297 2.8501 41.7197Z",
    fill: "#E0E9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34009 29.8298L17.9901 67.7198M3.34009 29.8298L22.2701 13.6998M3.34009 29.8298L22.0801 51.9498M22.2701 13.6998L41.0401 3.33984L56.7501 9.43984M22.2701 13.6998L56.7501 9.43984M56.7501 9.43984L65.2701 18.6898M56.7501 9.43984L45.5301 47.0198M56.7501 9.43984L41.7201 27.6798L45.5301 47.0198M77.1201 22.7498L65.2701 18.6798L71.9801 39.1598L59.0301 69.1998L45.5301 47.0198M77.6601 60.8098L59.0301 69.2098L41.7301 75.7498L22.0801 51.9498M22.0801 51.9498L18.0001 67.7198M29.7401 30.3698L41.7201 27.6698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.51 46.8604L41.73 75.7504L17.99 67.7204",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8899 27.6798C38.8899 29.2498 40.1599 30.5198 41.7299 30.5198C43.2999 30.5198 44.5699 29.2498 44.5699 27.6798C44.5699 26.1098 43.2999 24.8398 41.7299 24.8398C40.1599 24.8398 38.8899 26.1098 38.8899 27.6798Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.53 47.0204L65.27 18.6904L45.53 47.0204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.53 47.0204L65.27 18.6904",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4399 18.6896C62.4399 20.2596 63.7099 21.5296 65.2799 21.5296C66.8499 21.5296 68.1199 20.2596 68.1199 18.6896C68.1199 17.1196 66.8499 15.8496 65.2799 15.8496C63.7099 15.8496 62.4399 17.1196 62.4399 18.6896Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.28 22.7502C74.28 24.3202 75.55 25.5902 77.12 25.5902C78.69 25.5902 79.96 24.3202 79.96 22.7502C79.96 21.1802 78.69 19.9102 77.12 19.9102C75.55 19.9102 74.28 21.1802 74.28 22.7502Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8301 60.8097C74.8301 62.3797 76.1001 63.6497 77.6701 63.6497C79.2401 63.6497 80.5101 62.3797 80.5101 60.8097C80.5101 59.2397 79.2401 57.9697 77.6701 57.9697C76.1001 57.9697 74.8301 59.2397 74.8301 60.8097Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9199 9.43961C53.9199 11.0096 55.1899 12.2796 56.7599 12.2796C58.3299 12.2796 59.5999 11.0096 59.5999 9.43961C59.5999 7.86961 58.3299 6.59961 56.7599 6.59961C55.1899 6.59961 53.9199 7.86961 53.9199 9.43961Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4199 13.7004C19.4199 15.2704 20.6899 16.5404 22.2599 16.5404C23.8299 16.5404 25.0999 15.2704 25.0999 13.7004C25.0999 12.1304 23.8299 10.8604 22.2599 10.8604C20.6899 10.8604 19.4199 12.1304 19.4199 13.7004Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 29.9504C0.5 31.5204 1.77 32.7904 3.34 32.7904C4.91 32.7904 6.18 31.5204 6.18 29.9504C6.18 28.3804 4.91 27.1104 3.34 27.1104C1.77 27.1104 0.5 28.3804 0.5 29.9504Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2 3.34C38.2 4.91 39.47 6.18 41.04 6.18C42.61 6.18 43.88 4.91 43.88 3.34C43.88 1.77 42.61 0.5 41.04 0.5C39.47 0.5 38.2 1.77 38.2 3.34Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8899 75.6203C38.8899 77.1903 40.1599 78.4603 41.7299 78.4603C43.2999 78.4603 44.5699 77.1903 44.5699 75.6203C44.5699 74.0503 43.2999 72.7803 41.7299 72.7803C40.1599 72.7803 38.8899 74.0503 38.8899 75.6203Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1499 67.7199C15.1499 69.2899 16.4199 70.5599 17.9899 70.5599C19.5599 70.5599 20.8299 69.2899 20.8299 67.7199C20.8299 66.1499 19.5599 64.8799 17.9899 64.8799C16.4199 64.8799 15.1499 66.1499 15.1499 67.7199Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.24 51.9504C19.24 53.5204 20.51 54.7904 22.08 54.7904C23.65 54.7904 24.92 53.5204 24.92 51.9504C24.92 50.3804 23.65 49.1104 22.08 49.1104C20.51 49.1104 19.24 50.3804 19.24 51.9504Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3799 28.6802L66.6799 37.3902M76.9399 58.0602L73.6799 45.6402M33.9799 49.6902L24.8499 51.3502M76.2699 25.4602L74.2799 31.8302M29.7399 36.1202L34.6299 40.1902M22.3799 22.3702L22.3099 16.5302M28.4699 22.3702L39.4699 5.7002M13.3199 30.6902L6.16992 30.0702M22.3799 39.9302L22.1299 49.1202M75.0499 59.6902L59.8199 53.1502",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6299 36.3496H59.9699V60.0496H34.6299V36.3496Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6699 39.0898H56.9299V54.5898H37.6699V39.0898Z",
    fill: "#2B6BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6699 39.0898H56.9299V54.5898H37.6699V39.0898Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7501 54.5897C53.2701 51.0797 48.9101 49.3097 45.0101 50.6397C42.9801 51.3297 41.3801 52.7697 40.6101 54.5897H54.7501Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1 45.5304C51.07 47.2304 49.52 48.5904 47.63 48.5704C45.77 48.5504 44.28 47.2004 44.25 45.5304V43.9904C44.28 42.2904 45.83 40.9304 47.72 40.9504C49.58 40.9704 51.07 42.3204 51.1 43.9904V45.5304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1 45.5304C51.07 47.2304 49.52 48.5904 47.63 48.5704C45.77 48.5504 44.28 47.2004 44.25 45.5304V43.9904C44.28 42.2904 45.83 40.9304 47.72 40.9504C49.58 40.9704 51.07 42.3204 51.1 43.9904V45.5304Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1599 33.0596H80.2099V45.2596H67.1599V33.0596Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73 34.4697H78.64V42.4497H68.73V34.4697Z",
    fill: "#2B6BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73 34.4697H78.64V42.4497H68.73V34.4697Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.52 42.4499C76.76 40.6399 74.51 39.7299 72.5 40.4099C71.46 40.7699 70.63 41.5099 70.24 42.4499H77.52Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6401 37.7899C75.6301 38.6699 74.8301 39.3699 73.8501 39.3499C72.8901 39.3399 72.1201 38.6399 72.1101 37.7899V36.9999C72.1201 36.1199 72.9201 35.4199 73.9001 35.4399C74.8601 35.4499 75.6301 36.1499 75.6401 36.9999V37.7899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6401 37.7899C75.6301 38.6699 74.8301 39.3699 73.8501 39.3499C72.8901 39.3399 72.1201 38.6399 72.1101 37.7899V36.9999C72.1201 36.1199 72.9201 35.4199 73.9001 35.4399C74.8601 35.4499 75.6301 36.1499 75.6401 36.9999V37.7899Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5901 66.6797H69.6401V78.8797H56.5901V66.6797Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1499 68.0898H68.0599V76.0698H58.1499V68.0898Z",
    fill: "#2B6BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1499 68.0898H68.0599V76.0698H58.1499V68.0898Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9399 76.0701C66.1799 74.2601 63.9299 73.3501 61.9199 74.0301C60.8799 74.3901 60.0499 75.1301 59.6599 76.0701H66.9399Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07 71.41C65.06 72.29 64.26 72.99 63.28 72.97C62.32 72.96 61.55 72.26 61.54 71.41V70.62C61.55 69.74 62.35 69.04 63.33 69.06C64.29 69.07 65.06 69.77 65.07 70.62V71.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07 71.41C65.06 72.29 64.26 72.99 63.28 72.97C62.32 72.96 61.55 72.26 61.54 71.41V70.62C61.55 69.74 62.35 69.04 63.33 69.06C64.29 69.07 65.06 69.77 65.07 70.62V71.41Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0801 22.9805H31.6801V39.9305H13.0801V22.9805Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3101 24.9404H29.4501V36.0204H15.3101V24.9404Z",
    fill: "#2B6BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3101 24.9404H29.4501V36.0204H15.3101V24.9404Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84 36.0203C26.76 33.5103 23.56 32.2403 20.69 33.1903C19.2 33.6803 18.03 34.7103 17.46 36.0203H27.84Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1699 29.5398C25.1499 30.7598 24.0099 31.7298 22.6199 31.7098C21.2599 31.6898 20.1599 30.7298 20.1399 29.5398V28.4398C20.1599 27.2198 21.2999 26.2498 22.6899 26.2698C24.0499 26.2898 25.1499 27.2498 25.1699 28.4398V29.5398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1699 29.5398C25.1499 30.7598 24.0099 31.7298 22.6199 31.7098C21.2599 31.6898 20.1599 30.7298 20.1399 29.5398V28.4398C20.1599 27.2198 21.2999 26.2498 22.6899 26.2698C24.0499 26.2898 25.1499 27.2498 25.1699 28.4398V29.5398Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3119_3554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.85,
    height: 81.72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTeamCheckbox);
export default __webpack_public_path__ + "static/media/my-team-checkbox.4528f6c1c82c0efb81dc7c400db5c14f.svg";
export { ForwardRef as ReactComponent };